import React from 'react';

const FormField = ({ label, type = 'text', name, value, onChange, placeholder, required = true, options = [], suffix }) => {
  const baseClasses = "w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 focus:border-emerald-500 focus:outline-none focus:ring-1 focus:ring-emerald-500 shadow-sm transition-colors";

  return (
    <div className="flex flex-col gap-1.5">
      <label className="text-sm font-medium text-gray-700">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      
      <div className="relative">
        {type === 'select' ? (
          <select name={name} value={value} onChange={onChange} required={required} className={baseClasses}>
            <option value="" disabled>Selecciona una opción</option>
            {options.map(opt => (
              <option key={opt} value={opt}>{opt}</option>
            ))}
          </select>
        ) : type === 'textarea' ? (
          <textarea
            name={name}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            required={required}
            rows={3}
            className={`${baseClasses} resize-none`}
          />
        ) : (
          <div className="relative flex items-center">
            <input
              type={type}
              name={name}
              value={value}
              onChange={onChange}
              placeholder={placeholder}
              required={required}
              className={`${baseClasses} ${suffix ? 'pr-12' : ''}`}
            />
            {suffix && (
              <span className="absolute right-3 text-gray-500 text-sm select-none">
                {suffix}
              </span>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default FormField;